import React, { memo } from 'react';

import { Box } from '@mui/material';

import { errorDotIndicatorStyles } from './ErrorDotIndicator.styles';

const ErrorDotIndicator = () => <Box sx={errorDotIndicatorStyles} />;

export default memo(ErrorDotIndicator);
